import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { DataChannelSessionIntentionPromptMessage } from '../../video-sdk';
import { VisitorDrawerState, visitorDrawerStateAtom } from '../state';

export function useHandleReceivedSessionIntentionPromptCallback() {
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);

  return useCallback(
    async (_: DataChannelSessionIntentionPromptMessage) => {
      setDrawerState(VisitorDrawerState.INTENTIONS);
    },
    [setDrawerState],
  );
}
